<template>
  <TableList
    v-rect-loading="loading"
    class="offer-letter-template-list"
    row-key="id"
    showSearchFilter
    :title="$t(`${i18nPrefix}.title.offerLetterTemplateList`)"
    :listData="templateList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    :pagination="pagination"
    :createBtnLabel="$t(`${i18nPrefix}.btn.add`)"
    @create="handleCreateTemplate"
    @pagination-change="handlePaginationChange"
  >
    <template #search-filter>
      <div class="company-select">
        <span class="label">{{ $t(`${i18nPrefix}.label.companyName`) }}</span>
        <el-select v-model="selectCompany" filterable clearable @change="handleCompanySelect">
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.i18nName"
            :style="{ paddingLeft: item.level * 15 + 'px' }"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </template>
    <template #isEnabled="{ data, row }">
      <el-switch :value="data" :disabled="!row.can_edit" @change="onEnabledChange($event, row)"></el-switch>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.offerLetterInviteRecordManagement',
      loading: false,
      templateList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      actionBtn: {
        edit: {
          show: (row) => row.can_edit,
          onclick: this.handleEditTemplate
        },
        view: {
          show: true,
          onclick: this.handleViewTemplate,
          labelI18nKey: 'admin.company.offerLetterInviteRecordManagement.btn.view'
        }
      },
      companyList: [],
      selectCompany: null
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.templateName`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.templateStatus`),
          dataKey: 'is_enabled',
          slotName: 'isEnabled'
        }
      ]
      return columns
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('company', ['getCompanyChildrenTree']),
    ...mapActions('offerLetter', ['getOfferLetterTemplateList', 'updateOfferLetterTemplate']),
    async initPage () {
      await this.loadCompanyList()
      this.loadTemplateList()
    },
    async loadTemplateList () {
      this.loading = true
      try {
        const params = {
          page_num: this.pagination.page,
          page_size: this.pagination.pageSize,
          company_id: this.selectCompany
        }
        const resp = await this.getOfferLetterTemplateList(params)
        if (resp) {
          this.pagination.total = resp.total_count
          this.templateList = resp.result
        }
      } finally {
        this.loading = false
      }
    },
    async loadCompanyList () {
      const companyTreeResp = await this.getCompanyChildrenTree()
      const currentCompany = {
        id: companyTreeResp.self.id,
        name: companyTreeResp.self.name,
        cn_name: companyTreeResp.self.cn_name,
        level: companyTreeResp.self.level
      }
      const companyList = []
      this.companyList = this.formatCompanyData(companyTreeResp, currentCompany, companyList)
    },
    formatCompanyData (data, company, companyList) {
      addI18nProperty(company, 'i18nName', 'cn_name', 'name')
      companyList.push(company)
      const allChildren = data.children
      const children = allChildren[company.id]
      if (children && children.length > 0) {
        _.forEach(children, (child) => {
          this.formatCompanyData(data, child, companyList)
        })
      }
      return companyList
    },
    async onEnabledChange (isEnabled, row) {
      const templateInfo = row
      templateInfo.is_enabled = isEnabled
      this.loading = true
      try {
        const resp = await this.updateOfferLetterTemplate(templateInfo)
        if (resp) {
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    },
    handleCompanySelect () {
      this.loadTemplateList()
    },
    handleCreateTemplate () {
      this.$router.push('/v-admin/offer-letter-management/template/add')
    },
    handleEditTemplate (row) {
      if (!row.can_edit) {
        return
      }
      this.$router.push(`/v-admin/offer-letter-management/template/edit/${row.id}`)
    },
    handleViewTemplate (row) {
      this.$router.push(`/v-admin/offer-letter-management/template/view/${row.id}`)
    },
    handlePaginationChange () {
      this.loadTemplateList()
    }
  }
}
</script>

<style lang="scss" scoped>
.offer-letter-template-list {
  .company-select {
    display: flex;
    align-items: center;

    .el-select {
      margin-left: 14px;
      flex: 1;
    }
  }
}
</style>
